import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { actions } from 'features/creativeFunctionality/redux';
import { convertNotificationsCustom } from './convertNotificationsCustom';

const useNotificationsCustom = () => {
  const dispatch = useDispatch();
  const { notifyRequests } = useSelector(state => state.creativeFunctionality);

  const [notificationText, setNotificationText] = useState('');

  const handleCreateCustomNotification = () => {
    dispatch(actions.createCustomNotification(convertNotificationsCustom(notificationText)));
  };

  const handleSetNotificationText = e => {
    setNotificationText(e.target.value);
  };

  const handleGetNotificationsRequest = () => {
    dispatch(
      actions.getCustomRequests(
        {
          status: 'created',
          type: 'notification',
          date_from: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
          date_to: dayjs().format('YYYY-MM-DD'),
          is_my: true,
        },
        'notification',
      ),
    );
  };

  useEffect(() => {
    handleGetNotificationsRequest();
  }, []);

  return {
    values: {
      notificationText,
      notifyRequests,
    },
    handlers: {
      handleCreateCustomNotification,
      handleSetNotificationText,
      handleGetNotificationsRequest,
    },
  };
};

export default useNotificationsCustom;
